OnCloudVideo =
{
	p_video_src: '',
	p_video_id: '',
	init: function()
	{
		// Setup each video link.
		jQuery('.oc-video-btn').click(function(){
			OnCloudVideo.p_video_id = jQuery(this).data( 'video-id' );
			//$videoSrc = jQuery(this).data( "src" );
			OnCloudVideo.p_video_src = 'https://www.youtube.com/embed/' + OnCloudVideo.p_video_id;
		});
		
		// when the modal is opened autoplay it  
		jQuery('#oc-video-modal').on('shown.bs.modal', function (e) {
			jQuery('#oc-video').attr('src',OnCloudVideo.p_video_src + '?autoplay=1&amp;modestbranding=1&amp;showinfo=0' );
			//jQuery('#video-content').html('');
		});
		
		// stop playing the youtube video when I close the modal
		jQuery('#oc-video-modal').on('hide.bs.modal', function (e) {
			// A poor man's stop video
			jQuery('#oc-video').attr('src',''); 
		});
		
		// Setup each virtual tour link.
		jQuery('.oc-vtour-btn').click(function(){
			var vtour_html = jQuery(this).data( 'html' );
			jQuery('#oc-vtour-modal').find('#oc-vtour-content').html(vtour_html);
		});
	}
};//end object literal VideoNotices

jQuery(document).ready(function(jQuery){
	
	OnCloudVideo.init();
	
});
